import knightsConstantRedux from "../constant";

const initialSetting = {
  items: {
    enableMatrix: false,
    enableClienteling: false,
    enableStrictReturns: false,
    enableCommissions: false,
    enableWhatsApp: true,
  },
};

const posFeatures = (state = initialSetting, action, root) => {
  switch (action.type) {
    case knightsConstantRedux.SET_POS_FEATURES:
      return {
        ...state,
        items: action.payload.posFeatures,
      };
    
    default:
      return state;
  }
};

export default posFeatures;
